import React, { Suspense, useLayoutEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ProductContextProvider } from "../pages/pre-built/products/ProductContext";
import { UserContextProvider } from "../pages/pre-built/user-manage/UserContext";
import { RedirectAs404, getPublicUrl } from "../utils/Utils";
import AdminRoute from "./AdminRoute";

import Homepage from "../pages/Homepage";

import Blank from "../pages/others/Blank";
import Faq from "../pages/others/Faq";
import Regularv1 from "../pages/others/Regular-1";
import Regularv2 from "../pages/others/Regular-2";
import Terms from "../pages/others/Terms";

import ProjectCardPage from "../pages/pre-built/projects/ProjectCard";
import ProjectListPage from "../pages/pre-built/projects/ProjectList";
import UserContactCardPage from "../pages/pre-built/user-manage/UserContactCard";
import UserDetailsPage from "../pages/pre-built/user-manage/UserDetailsRegular";
import UserListCompact from "../pages/pre-built/user-manage/UserListCompact";
import UserQuotes from "../pages/pre-built/user-manage/quotes";
import Enterprise from "../pages/pre-built/user-manage/Enterprise";
import Employees from "../pages/pre-built/user-manage/Employee";
import Broker from "../pages/pre-built/user-manage/Broker";
import MedicalPartner from "../pages/pre-built/user-manage/MedicalPartner";
import MedicalPartnerDetails from "../pages/pre-built/user-manage/MedicalPartnerDetails";
import ClinicManagement from "../pages/pre-built/user-manage/ClinicManagement";
import ClinicPrices from "../pages/pre-built/user-manage/ClinicPrices";
import MyClinics from "../pages/pre-built/user-manage/MyClinics";
import ContactForm from "../pages/pre-built/user-manage/ContactForm";
import PartnerLeads from "../pages/pre-built/user-manage/PartnerLeads";
import LeadCircles from "../pages/pre-built/user-manage/LeadCircles";
import MediaLibrary from "../pages/pre-built/user-manage/MediaLibrary";
import PartnerPricesList from "../pages/pre-built/user-manage/PartnerPricesList";
import TeleconsultationList from "../pages/pre-built/user-manage/TeleconsultationList";
import TeleconsultationPendingPartners from "../pages/pre-built/user-manage/TeleconsultationPendingPartners";
import PractitionerApprovals from "../pages/pre-built/user-manage/PractitionerApprovals";
import TeleconsultationDetail from "../pages/pre-built/user-manage/TeleconsultationDetail";
import TeleconsultationStats from "../pages/pre-built/user-manage/TeleconsultationStats";
import TeleconsultationOperationsDashboard from "../pages/pre-built/user-manage/TeleconsultationOperationsDashboard";
import PartnerSupportRequestsList from "../pages/pre-built/user-manage/PartnerSupportRequestsList";
import PartnerSupportRequestDetail from "../pages/pre-built/user-manage/PartnerSupportRequestDetail";
import NavigationItemsAdmin from "../pages/pre-built/user-manage/NavigationItemsAdmin";
import ClinicCalendarAdmin from "../pages/pre-built/user-manage/ClinicCalendarAdmin";
import ClinicPractitionersAdmin from "../pages/pre-built/user-manage/ClinicPractitionersAdmin";
import PractitionersDirectory from "../pages/pre-built/user-manage/PractitionersDirectory";
import ReportsList from "../pages/pre-built/user-manage/ReportsList";
import IntegrationsPage from "../pages/pre-built/user-manage/IntegrationsPage";
import PrescriptionRegulationsPage from "../pages/pre-built/user-manage/PrescriptionRegulationsPage";
import SoExperts from "../pages/pre-built/user-manage/SoExperts";
import SoCases from "../pages/pre-built/user-manage/SoCases";
import SoCaseDetail from "../pages/pre-built/user-manage/SoCaseDetail";
import SoOffers from "../pages/pre-built/user-manage/SoOffers";
import ParentSpecialtyLayout from "../pages/pre-built/specialty-manage/ParentSpecialtyLayout";
import SystemSettings from "../pages/pre-built/user-manage/SystemSettings";
import AdminSettingsHubPage from "../pages/pre-built/user-manage/AdminSettingsHubPage";
import PlatformSetupPage from "../pages/pre-built/user-manage/PlatformSetupPage";
import PlatformCatalogRootsPage from "../pages/pre-built/user-manage/PlatformCatalogRootsPage";
import EmailTemplatesManagement from "../pages/pre-built/user-manage/EmailTemplatesManagement";
import RbacAdmins from "../pages/pre-built/user-manage/RbacAdmins";
import RbacRoles from "../pages/pre-built/user-manage/RbacRoles";
import RbacAudit from "../pages/pre-built/user-manage/RbacAudit";

import UserProfileLayout from "../pages/pre-built/user-manage/UserProfileLayout";
import KycListRegular from "../pages/pre-built/kyc-list-regular/KycListRegular";
import KycDetailsRegular from "../pages/pre-built/kyc-list-regular/kycDetailsRegular";
import TransListBasic from "../pages/pre-built/trans-list/TransListBasic";
import TransListCrypto from "../pages/pre-built/trans-list/TransListCrypto";
import ProductCard from "../pages/pre-built/products/ProductCard";
import ProductList from "../pages/pre-built/products/ProductList";
import ProductDetails from "../pages/pre-built/products/ProductDetails";
import InvoiceList from "../pages/pre-built/invoice/InvoiceList";
import InvoiceDetails from "../pages/pre-built/invoice/InvoiceDetails";
import PricingTable from "../pages/pre-built/pricing-table/PricingTable";
import Gallery from "../pages/pre-built/gallery/GalleryCard";

import AppMessages from "../pages/app/messages/Messages";
import Chat from "../pages/app/chat/ChatContainer";
import Calender from "../pages/app/calender/Calender";

const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<div />}>
      <Switch>
        {/*Dashboards*/}
        <Route exact path={getPublicUrl("_blank")} component={Blank}></Route>

        {/*Pre-built Pages*/}
        <Route exact path={getPublicUrl("project-card")} component={ProjectCardPage}></Route>
        <Route exact path={getPublicUrl("project-list")} component={ProjectListPage}></Route>
        <Route
          exact
          path={getPublicUrl("user-list-regular")}
          render={() => <Redirect to={getPublicUrl("user-list-compact")} />}
        ></Route>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("user-list-compact")}
          render={() => (
            <UserContextProvider>
              <UserListCompact />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <Route //Context Api added
          exact
          path={getPublicUrl("user-details-regular/:id")}
          render={(props) => (
            <UserContextProvider>
              <UserDetailsPage {...props} />
            </UserContextProvider>
          )}
        ></Route>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("user-quotes")}
          render={() => (
            <UserContextProvider>
              <UserQuotes />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("enterprise")}
          render={() => (
            <UserContextProvider>
              <Enterprise />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("employee")}
          render={() => (
            <UserContextProvider>
              <Employees />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("broker")}
          render={() => (
            <UserContextProvider>
              <Broker />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("medical-partner")}
          render={() => (
            <UserContextProvider>
              <MedicalPartner />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("medical-partner-details/:id")}
          render={() => (
            <UserContextProvider>
              <MedicalPartnerDetails />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("clinics")}
          render={() => (
            <UserContextProvider>
              <ClinicManagement />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("clinics/:id/prices")}
          render={() => (
            <UserContextProvider>
              <ClinicPrices />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute exact path={getPublicUrl("clinics/:clinicId/calendar")} component={ClinicCalendarAdmin} />
        <AdminRoute exact path={getPublicUrl("clinics/:clinicId/practitioners")} component={ClinicPractitionersAdmin} />
        <AdminRoute exact path={getPublicUrl("practitioners")} component={PractitionersDirectory} />
        <AdminRoute exact path={getPublicUrl("my-clinics")} component={MyClinics}></AdminRoute>
        <AdminRoute exact path={getPublicUrl("clinics-landing")} component={MyClinics}></AdminRoute>
        <Route
          exact
          path={getPublicUrl("clinic-media")}
          render={() => <Redirect to={getPublicUrl("my-clinics")} />}
        ></Route>
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("contact-form")}
          render={() => (
            <UserContextProvider>
              <ContactForm />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute exact path={getPublicUrl("partner-leads")} component={PartnerLeads}></AdminRoute>
        <AdminRoute exact path={getPublicUrl("lead-circles")} component={LeadCircles}></AdminRoute>
        <AdminRoute exact path={getPublicUrl("partner-prices")} component={PartnerPricesList} />
        <AdminRoute exact path={getPublicUrl("media-library")} component={MediaLibrary} />
        <AdminRoute //Context Api added - Protected Admin Route
          exact
          path={getPublicUrl("specialty-list")}
          render={() => (
            <UserContextProvider>
              <ParentSpecialtyLayout />
            </UserContextProvider>
          )}
        ></AdminRoute>
        <AdminRoute exact path={getPublicUrl("admin-settings")} component={AdminSettingsHubPage} />
        <AdminRoute exact path={getPublicUrl("rbac-admins")} component={RbacAdmins} />
        <AdminRoute exact path={getPublicUrl("rbac-roles")} component={RbacRoles} />
        <AdminRoute exact path={getPublicUrl("rbac-audit")} component={RbacAudit} />
        <AdminRoute exact path={getPublicUrl("system-settings")} component={SystemSettings} />
        <AdminRoute exact path={getPublicUrl("platform-setup")} component={PlatformSetupPage}></AdminRoute>
        <AdminRoute exact path={getPublicUrl("platform-catalog-roots")} component={PlatformCatalogRootsPage} />
        <AdminRoute
          exact
          path={getPublicUrl("email-templates-management")}
          component={EmailTemplatesManagement}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations")}
          component={TeleconsultationList}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/pending-partners")}
          component={TeleconsultationPendingPartners}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/practitioner-approvals")}
          component={PractitionerApprovals}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/stats")}
          component={TeleconsultationStats}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/operations")}
          component={TeleconsultationOperationsDashboard}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/support-requests")}
          component={PartnerSupportRequestsList}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/support-requests/:id")}
          component={PartnerSupportRequestDetail}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/navigation-items")}
          component={NavigationItemsAdmin}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("teleconsultations/:id")}
          component={TeleconsultationDetail}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("reports")}
          component={ReportsList}
        ></AdminRoute>
        <AdminRoute exact path={getPublicUrl("integrations")} component={IntegrationsPage}></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("prescription-regulations")}
          component={PrescriptionRegulationsPage}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("second-opinion/cases")}
          component={SoCases}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("second-opinion/cases/:caseId")}
          component={SoCaseDetail}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("second-opinion/experts")}
          component={SoExperts}
        ></AdminRoute>
        <AdminRoute
          exact
          path={getPublicUrl("second-opinion/offers")}
          component={SoOffers}
        ></AdminRoute>
        <Route exact path={getPublicUrl("user-profile-regular/")} component={UserProfileLayout}></Route>
        <Route
          exact
          path={getPublicUrl("user-profile-notification/")}
          component={UserProfileLayout}
        ></Route>
        <Route exact path={getPublicUrl("user-profile-activity/")} component={UserProfileLayout}></Route>
        <Route exact path={getPublicUrl("user-profile-setting/")} component={UserProfileLayout}></Route>
        <Route //Context api added
          exact
          path={getPublicUrl("user-contact-card")}
          render={() => (
            <UserContextProvider>
              <UserContactCardPage />
            </UserContextProvider>
          )}
        ></Route>
        <Route exact path={getPublicUrl("kyc-list-regular")} component={KycListRegular}></Route>
        <Route exact path={getPublicUrl("kyc-details-regular/:id")} component={KycDetailsRegular}></Route>
        <Route exact path={getPublicUrl("transaction-basic")} component={TransListBasic}></Route>
        <Route exact path={getPublicUrl("transaction-crypto")} component={TransListCrypto}></Route>
        <Route exact path={getPublicUrl("product-list")} component={ProductList}></Route>

        <Route // context api added
          exact
          path={getPublicUrl("product-card")}
          render={(props) => (
            <ProductContextProvider>
              <ProductCard />
            </ProductContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={getPublicUrl("product-details/:id")}
          render={(props) => (
            <ProductContextProvider>
              <ProductDetails {...props} />
            </ProductContextProvider>
          )}
        ></Route>
        <AdminRoute exact path={getPublicUrl("invoice-list")} component={InvoiceList}></AdminRoute>
        <AdminRoute exact path={getPublicUrl("invoice-details/:id")} component={InvoiceDetails}></AdminRoute>
        <Route exact path={getPublicUrl("pricing-table")} component={PricingTable}></Route>
        <Route exact path={getPublicUrl("image-gallery")} component={Gallery}></Route>

        {/*Demo Pages*/}
        <Route exact path={getPublicUrl("pages/terms-policy")} component={Terms}></Route>
        <Route exact path={getPublicUrl("pages/faq")} component={Faq}></Route>
        <Route exact path={getPublicUrl("pages/regular-v1")} component={Regularv1}></Route>
        <Route exact path={getPublicUrl("pages/regular-v2")} component={Regularv2}></Route>

        {/*Application*/}
        <Route exact path={getPublicUrl("app-messages")} component={AppMessages}></Route>
        <Route exact path={getPublicUrl("app-chat")} component={Chat}></Route>
        <Route exact path={getPublicUrl("app-calender")} component={Calender}></Route>

        {/* Dashboard - Protected Admin Route */}
        <AdminRoute exact path={getPublicUrl("")} component={Homepage}></AdminRoute>
        <AdminRoute exact path="/" component={Homepage}></AdminRoute>
        {/* Route 404 - doit être la dernière */}
        <Route component={RedirectAs404}></Route>
      </Switch>
    </Suspense>
  );
};
export default Pages;
